import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// 🔹 Word Component (IMPORTANT FIX)
const Word = ({ word, index, total, scrollYProgress }) => {
  const start = index / total;
  const end = (index + 1) / total;

  const color = useTransform(
    scrollYProgress,
    [start, end],
    ["#666666", "#ffffff"]
  );

  return <motion.span style={{ color }}>{word} </motion.span>;
};

// 🔹 Main Component
const HighlightText = () => {
  const { scrollYProgress } = useScroll();

  const text =
    "Elevate your digital presence with Rayo - dynamic and stylish template designed for creative agencies and personal brands.";

  const words = text.split(" ");

  return (
    <section
      style={{
        height: "80vh",
        background: "#050505",
        display: "flex",
        alignItems: "top",
        justifyContent: "center",
        padding: "100px",
      }}
    >
      <h1
        style={{
          fontSize: "48px",
          lineHeight: "1.4",
          fontWeight: "600",
          maxWidth: "900px",
        }}
      >
        {words.map((word, i) => (
          <Word
            key={i}
            word={word}
            index={i}
            total={words.length}
            scrollYProgress={scrollYProgress}
          />
        ))}
      </h1>
    </section>
  );
};

export default HighlightText;